import type { FirstPartyIdentityCapture } from "./types";

/** One successful protected network capture per page; retries retain consent fencing. */
export function createCompanyVisitCapture(options: {
  enabled: () => boolean;
  allowed: () => boolean;
  capture: (input: FirstPartyIdentityCapture) => Promise<boolean>;
}) {
  let accepted = false;
  let pending = false;
  return async () => {
    if (accepted || pending || !options.enabled() || !options.allowed()) return;
    pending = true;
    try {
      accepted = await options.capture({
        source: "visit_company",
        purposes: ["identity_resolution", "enrichment"],
      });
    } catch {
      // Collection is optional. A later consent transition can retry safely.
    } finally {
      pending = false;
    }
  };
}
